export const CHANGE_ACTIVE_VOTE_OPTION = 'Widget::VoteForm::Change::VoteOption';

/* Form possible states constants */
export const VOTE_FORM_STATE_ACTIVE = 'ReadyForVote';
export const VOTE_FORM_STATE_RESULTS = 'ViewResults';
export const VOTE_FORM_STATE_ALREADY = 'AlreadyVoted';

export const VOTE_COOKIE_NAME = 'alreadyVoted';
